import { ComponentProps, PropsWithChildren } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { FormRow, Text } from '@frontend/design-system';

type Props = ComponentProps<typeof FormRow> & { title?: string };

export const AvailabilityFormRow = ({ children, title, ...props }: PropsWithChildren<Props>) => {
  return (
    <>
      {title && (
        <Text weight='bold' color='subdued' css={titleStyles}>
          {title}
        </Text>
      )}
      <FormRow {...props} css={formRowStyles}>
        {children}
      </FormRow>
    </>
  );
};

const titleStyles = css({
  fontWeight: theme.font.weight.bold,
  color: theme.font.colors.subdued,
  marginBottom: theme.spacing(1),
});

const formRowStyles = css({
  label: {
    '&:not([class*="InlineLabel"])': titleStyles,
  },
});
